import Vue from 'vue';
import Router from 'vue-router';
import i18n from '../i18n';
import { isAllowedTo } from '../utils/capabilites';

// View imports
import Dashboard from '@/views/dashboard/Dashboard';
import StatisticsView from '@/views/statistics/StatisticsView';
import UsersView from '@/views/users/UsersView';
import BuildingsView from '@/views/buildings/BuildingsView';
import BuildingDetailView from '@/views/buildings/BuildingDetailView';
import FloorView from '@/views/buildings/FloorView';
import FloorDetailView from '@/views/floors/FloorDetailView';
import FireProtectionView from '@/views/fireProtection/FireProtectionView';
import RolesView from '@/views/roles/RolesView';
import QuestionsView from '@/views/questions/QuestionsView';
import QuestionsDetailView from '@/views/questions/QuestionsDetailView';
import ChecklistView from '@/views/checklists/ChecklistView';
import ChecklistDetailView from '@/views/checklists/ChecklistDetailView';
import RoundPlanningView from '@/views/roundplanning/RoundPlanningView';
import RoundPlanningDetailView from '@/views/roundplanning/RoundPlanningDetailView';
import StartRoundView from '@/views/start-round/StartRoundView';
import RoundView from '@/views/round/RoundView';
import FinishedRoundView from '@/views/round/FinishedRoundView';
import FileView from '@/views/files/FileView';
import ApiKeyView from '@/views/apiKeys/ApiKeyView';
import RecoverPassword from '@/views/recover-password/RecoverPassword';
import ResetPassword from '@/views/reset-password/ResetPassword';
import Login from '@/views/login/LoginView';
import Changelog from '@/views/changelog/Changelog';
import LicenseView from '@/views/license/License';
import OngoingMovesView from '@/views/move-wizard/OngoingMovesView';
import MoveWizardView from '@/views/move-wizard/MoveWizardView';
import MoveSummaryView from '@/views/move-wizard/MoveSummaryView';
import RoundHistoryView from '@/views/round-history/RoundHistoryView';

Vue.use(Router);

const appRoutes = [
  { path: '', name: 'Dashboard', component: Dashboard },
  { path: 'statistics', name: 'Statistics', component: StatisticsView },
  { path: 'login', name: 'Login', component: Login, meta: { layout: 'plain' } },
  { path: 'recover-password', name: 'RecoverPassword', component: RecoverPassword, meta: { layout: 'plain' } },
  { path: 'reset-password/:token/:email', name: 'ResetPassword', component: ResetPassword, meta: { layout: 'plain' } },
  { path: 'users', name: 'UsersView', component: UsersView, beforeEnter: (to, from, next) => isAllowedTo('users_access_view') ? next() : next('/') },
  { path: 'buildings', name: 'BuildingsView', component: BuildingsView, beforeEnter: (to, from, next) => isAllowedTo('buildings_access_view') ? next() : next('/') },
  { path: 'buildings/:buildingId', name: 'BuildingDetailView', component: BuildingDetailView, beforeEnter: (to, from, next) => isAllowedTo('buildings_access_view') ? next() : next('/') },
  { path: 'floors/:buildingId', name: 'FloorView', component: FloorView, beforeEnter: (to, from, next) => isAllowedTo('floors_edit') ? next() : next('/') },
  { path: 'floor/:floorId', name: 'FloorDetailView', component: FloorDetailView, beforeEnter: (to, from, next) => isAllowedTo('floors_edit') ? next() : next('/') },
  { path: 'fireprotection', name: 'FireProtectionView', component: FireProtectionView, beforeEnter: (to, from, next) => isAllowedTo('fireprotections_access_view') ? next() : next('/') },
  { path: 'roles', name: 'RolesView', component: RolesView, beforeEnter: (to, from, next) => isAllowedTo('roles_access_view') ? next() : next('/') },
  { path: 'questions', name: 'QuestionsView', component: QuestionsView, beforeEnter: (to, from, next) => isAllowedTo('questions_access_view') ? next() : next('/') },
  { path: 'questions/:questionGroupId', name: 'QuestionsDetailView', component: QuestionsDetailView, beforeEnter: (to, from, next) => isAllowedTo('questions_access_view') ? next() : next('/') },
  { path: 'checklists', name: 'ChecklistView', component: ChecklistView, beforeEnter: (to, from, next) => isAllowedTo('checklists_access_view') ? next() : next('/') },
  { path: 'checklist/:checklistId', name: 'ChecklistDetailView', component: ChecklistDetailView, beforeEnter: (to, from, next) => isAllowedTo('checklists_access_view') ? next() : next('/') },
  { path: 'roundplanning', name: 'RoundPlanningView', component: RoundPlanningView, beforeEnter: (to, from, next) => isAllowedTo('roundplannings_access_view') ? next() : next('/') },
  {
    path: 'roundplanning/:roundPlanningId',
    name: 'RoundPlanningDetailView',
    component: RoundPlanningDetailView,
    beforeEnter: (to, from, next) => {
      const capability = String(to.params.roundPlanningId) === '0'
        ? 'roundplannings_create'
        : 'roundplannings_edit';

      return isAllowedTo(capability) ? next() : next('/');
    }
  },
  { path: 'startround/:roundId', name: 'StartRoundView', component: StartRoundView, beforeEnter: (to, from, next) => isAllowedTo('roundplannings_perform_round') ? next() : next('/') },
  { path: 'round/:roundId', name: 'RoundView', component: RoundView, beforeEnter: (to, from, next) => isAllowedTo('roundplannings_perform_round') ? next() : next('/') },
  { path: 'round/done/:roundId/:print?', name: 'FinishedRoundView', component: FinishedRoundView, beforeEnter: (to, from, next) => isAllowedTo('roundplannings_perform_round') ? next() : next('/') },
  { path: 'documents', name: 'Documents', component: FileView, beforeEnter: (to, from, next) => isAllowedTo('documents_access_view') ? next() : next('/') },
  { path: 'license', name: 'Licenser', component: LicenseView, beforeEnter: (to, from, next) => isAllowedTo('licenses_access_view') ? next() : next('/') },
  { path: 'apikeys', name: 'Apikeys', component: ApiKeyView, beforeEnter: (to, from, next) => isAllowedTo('apikeys_access_view') ? next() : next('/') },
  { path: 'changelog', name: 'Changelog', component: Changelog, beforeEnter: (to, from, next) => isAllowedTo('changelogs_access_view') ? next() : next('/') },
  { path: 'OngoingMoves', name: 'OngoingMovesView', component: OngoingMovesView, beforeEnter: (to, from, next) => isAllowedTo('changelogs_access_view') ? next() : next('/') },
  { path: 'MoveWizard/:moveId', name: 'MoveWizardView', component: MoveWizardView, beforeEnter: (to, from, next) => isAllowedTo('changelogs_access_view') ? next() : next('/') },
  { path: 'MoveSummary/:moveId', name: 'MoveSummaryView', component: MoveSummaryView, beforeEnter: (to, from, next) => isAllowedTo('changelogs_access_view') ? next() : next('/') },
  { path: 'round-history/:buildingId', name: 'RoundHistoryView', component: RoundHistoryView, beforeEnter: (to, from, next) => isAllowedTo('roundhistory_access_view') ? next() : next('/') }
];





export const routes = [
  {
    path: '/:lang',
    component: {
      render(c) {
        return c('router-view');
      }
    },
    children: appRoutes
  },
  {
    path: '/',
    redirect: () => {
      const storedLang = localStorage.getItem('lang');
      const lang = ['sv', 'en', 'fi'].includes(storedLang) ? storedLang : (navigator.language.startsWith('sv') ? 'sv' : 'en');
      return `/${lang}`;
    }
  },
  {
    path: '*',
    redirect: () => {
      const storedLang = localStorage.getItem('lang');
      const lang = ['sv', 'en', 'fi'].includes(storedLang) ? storedLang : 'sv';
      return `/${lang}`;
    }
  }
];


const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  routes 
});

router.onError((err) => {
  const msg = err && err.message ? err.message : '';
  if (
    msg.includes('Navigation aborted') ||
    msg.includes('Navigation cancelled') ||
    msg.includes('NavigationDuplicated')
  ) {
    return;
  }
  console.error(err);
});
 


router.beforeEach((to, from, next) => {
  const lang = to.params.lang;
  if (!['en', 'sv', 'fi'].includes(lang)) return next('/sv');
  if (i18n.locale !== lang) i18n.locale = lang;
  next();
});


